export function wait(delay) {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(null);
        }, delay);
    });
}
export function queueAsyncCalls(callback) {
    let lastPromise;
    return (...args) => {
        const currentPromise = new Promise((resolve, reject) => {
            const callCallback = () => {
                return callback(...args)
                    .then(resolve)
                    .catch(reject);
            };
            if (!lastPromise) {
                lastPromise = callCallback();
            }
            else {
                lastPromise = lastPromise.finally(callCallback).catch(() => {
                    // swallow the error from previous promise
                    // so it doesn't affect the current promise
                });
            }
        });
        return currentPromise;
    };
}
export function abortable(task, abortSignal) {
    return new Promise((resolve, reject) => {
        // If already aborted, reject immediately
        if (abortSignal.aborted) {
            return reject(new Error('Aborted'));
        }
        // Listen for abort
        const onAbort = () => {
            reject(new Error('Aborted'));
        };
        abortSignal.addEventListener('abort', onAbort, { once: true });
        // Run the actual task
        Promise.resolve()
            .then(task)
            .then(resolve, reject)
            .finally(() => {
            // cleanup listener
            abortSignal.removeEventListener('abort', onAbort);
        });
    });
}
